import { useCallback, useMemo } from 'react';
import { t } from 'i18next';

import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { minItemsArrayUtils } from '@/modules/floorplanDesign/helpers/minItems';
import { useReadSelectedObstacles } from '@/modules/floorplanDesign/hooks/useReadSelectedObstacles';
import { IFddmService } from '@/modules/canvas/services/Floorplan/IFddmService';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { NumberInput } from '@/modules/common/components/inputs/components/NumberInput';
import { METERS_TO_MILLIMETERS_FACTOR } from '@/modules/canvas/factories/element';

function Height() {
  const obstacles = useReadSelectedObstacles();
  const fddmSvc: IFddmService = useMemo(
    () => FddmServiceFactory.getInstance().createFddmService(),
    [],
  );

  const onChange = useCallback(
    (newValue: number) => {
      const valueInMeter = newValue / METERS_TO_MILLIMETERS_FACTOR;
      const obstacle = obstacles[0];

      fddmSvc.updateObstacle({
        ...obstacle,
        segments: minItemsArrayUtils.mapAtLeast1(obstacle.segments, (segment) => ({
          ...segment,
          height: valueInMeter,
        })),
      });
    },
    [obstacles, fddmSvc],
  );

  if (obstacles.length !== 1) return null;

  const { appearance, segments } = obstacles[0];
  const height = segments[0]?.height;
  if ((appearance !== 'BOX' && appearance !== 'WALL') || height === undefined) return null;

  return (
    <PropertiesLabel i18nkey='interface:properties.wall.height'>
      <NumberInput
        value={height * METERS_TO_MILLIMETERS_FACTOR}
        errorType='floating'
        unit={t(`interface:settings.units.mm`, 'mm')}
        minValue={0}
        onChange={onChange}
      />
    </PropertiesLabel>
  );
}

export default Height;
